import "./App.css";
import Header from "./components/header";
import Home from "./components/home";
import Content from "./components/content";
import SecretPwCheck from "./components/secretPwCheck";
import { Routes, Route, Navigate, useParams } from "react-router";

function LegacySecretRedirect() {
  const { date } = useParams();
  return <Navigate to={`/${date}`} replace />;
}

function App() {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/:date" element={<Content />} />
        <Route path="/auth" element={<SecretPwCheck />} />
        <Route path="/secret" element={<Navigate to="/" replace />} />
        <Route path="/secret/:date" element={<LegacySecretRedirect />} />
        {/* 404 페이지 */}
        <Route path="*" element={<div>404 Page Not Found</div>} />
      </Routes>
    </div>
  );
}

export default App;
